import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { RcTypography } from '../../Typography';
import { useDialogDefaultProps } from '../utils';
import { DialogTitleStyle } from './styles';
import { RcDialogTitleClasses, RcDialogTitleTypographyVariant } from './utils';
var _RcDialogTitle = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcDialogTitle' });
    var classesProp = props.classes, display = props.display, space = props.space, children = props.children, disableTypography = props.disableTypography, size = props.size, rest = __rest(props, ["classes", "display", "space", "children", "disableTypography", "size"]);
    var classes = useMemo(function () { return combineClasses(RcDialogTitleClasses, classesProp); }, [classesProp]);
    return (React.createElement(MuiDialogTitle, __assign({}, rest, { disableTypography: true, ref: ref, classes: classes }), disableTypography ? (children) : (React.createElement(RcTypography, { variant: RcDialogTitleTypographyVariant[size], component: "h2" }, children))));
});
var RcDialogTitle = styled(_RcDialogTitle).attrs(useDialogDefaultProps)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), DialogTitleStyle);
RcDialogTitle.defaultProps = {};
RcDialogTitle.displayName = 'RcDialogTitle';
export { RcDialogTitle };
var templateObject_1;
